export const Sort = () => {
    return {
        sort: 'name',
        direction: 'asc',
        dataItems: null,

        get data () {
            return this.dataItems;
        },

        set data ( data ) {
            this.dataItems = data;
        },

        open ( index = true, toggle = true ) {

            if ( !toggle ) {
                this.selected = index;
            } else {
                this.selected = this.isOpen( index ) ? false : index;
            }

        },

        update ( sort ) {
            if ( this.sort === sort ) {
                this.direction = ( this.direction === 'asc' ) ? 'desc' : 'asc'
            } else {
                this.sort = sort;
                this.direction = 'asc';
            }
        },

        sortData() {
            this.data = ( this.direction === 'asc' ) ? this.sortDataAsc() : this.sortDataDesc()
            return this.data;
        },

        sortDataAsc () {
            return this.data.sort( ( a, b ) => {
                if(Number(a.sort[ this.sort ])) {
                    return b.sort[ this.sort ] - a.sort[ this.sort ]
                } else {
                    return a.sort[ this.sort ].localeCompare(b.sort[ this.sort ])
                }
            } );
        },

        sortDataDesc () {
            return this.data.sort( ( a, b ) => {
                if(Number(a.sort[ this.sort ])) {
                    return a.sort[ this.sort ] - b.sort[ this.sort ]
                } else {
                    return b.sort[ this.sort ].localeCompare(a.sort[ this.sort ])
                }
            } );
        },

        activeSort(name, direction = null) {

            if(direction) {
                return this.sort === name && this.direction === direction;
            }

            return this.sort === name;

        }
    }
}
